/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import { Autocomplete, Box, Button, TextField } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { getTeamV4Filter, getRepFilter, getDoctorFilter } from '../../../api/filterOptionsApi';
// Helpers
import {
  filterValue,
  filterMultiValue,
  filterTeamV4Options,
  filterRepOptions,
  filterDoctorv2Options,
} from '../../../helpers/filterFunctions';
import useStore from '../../../states/store';
import useMasterlistContext from '../context/useMasterlistContext';

function Filter() {
  const { filterForm, setFilterForm, handleGeneratelist, handleClearList } =
    useContext(useMasterlistContext);

  const auth = useStore((state) => state.auth);
  const [teamOptions, setTeamOptions] = useState({ loading: false, data: [] });
  const [repOptions, setRepOptions] = useState({ loading: false, data: [] });
  const [mdOptions, setMdOptions] = useState({ loading: false, data: [] });

  const loadTeamDropdown = async () => {
    setTeamOptions({ loading: true, data: [] });
    const request = {
      rep_id: filterValue(filterForm?.rep_id),
      md_id: filterMultiValue(filterForm?.md_id),
      date_from: moment(filterForm?.month_year).startOf('month').format('YYYY-MM-DD'),
      date_to: moment(filterForm?.month_year).endOf('month').format('YYYY-MM-DD'),
    };
    const reponse = await getTeamV4Filter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      let newDropdownValue;
      const dropdownValue = filterTeamV4Options(data);

      if (auth?.designation === 'SAM' || auth?.designation === 'KASM') {
        newDropdownValue = dropdownValue;
      } else {
        newDropdownValue = [{ label: 'ALL', value: null }, ...dropdownValue];
      }

      if (dropdownValue.length < 2) {
        setFilterForm({ ...filterForm, team: dropdownValue[0] });
      } else {
        setFilterForm({ ...filterForm, team: { label: 'ALL', value: null } });
      }

      setTeamOptions({
        ...teamOptions,
        loading: false,
        data: newDropdownValue,
      });
    }
  };

  const loadRepDropdown = async () => {
    setRepOptions({ loading: true, data: [] });
    const request = {
      rep_team: filterValue(filterForm?.team),
      md_id: filterMultiValue(filterForm?.md_id),
      date_from: moment(filterForm?.month_year).startOf('month').format('YYYY-MM-DD'),
      date_to: moment(filterForm?.month_year).endOf('month').format('YYYY-MM-DD'),
    };
    const reponse = await getRepFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);

      setRepOptions({
        ...repOptions,
        loading: false,
        data: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  const loadMDDropdown = async () => {
    setMdOptions({ loading: true, data: [] });
    const request = {
      rep_team: filterValue(filterForm?.team),
      rep_id: filterValue(filterForm?.rep_id),
      date_from: moment(filterForm?.month_year).startOf('month').format('YYYY-MM-DD'),
      date_to: moment(filterForm?.month_year).endOf('month').format('YYYY-MM-DD'),
    };
    const response = await getDoctorFilter(request);
    const { code, data } = response.data;

    if (code === '200') {
      const dropdownValue = filterDoctorv2Options(data);
      setMdOptions({
        ...mdOptions,
        loading: false,
        data: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const handleChangeMonth = (value) => {
    setFilterForm({ ...filterForm, month_year: moment(value).format('YYYY-MM') });
  };

  useEffect(() => {
    loadRepDropdown();
    loadMDDropdown();
  }, [filterForm?.team]);

  useEffect(() => {
    loadTeamDropdown();
    loadMDDropdown();
  }, [filterForm?.rep_id]);

  useEffect(() => {
    loadTeamDropdown();
    loadRepDropdown();
  }, [filterForm?.md_id]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='team'
            disableClearable
            fullWidth
            loading={teamOptions.loading}
            options={teamOptions.data}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Team' />}
            size='small'
            value={filterForm?.team}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'team')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>

        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            loading={repOptions.loading}
            options={repOptions.data}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Medical Representative' />}
            size='small'
            value={filterForm?.rep_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>

        {/* <Grid md={2}>
          <Autocomplete
            disablePortal
            id='md_id'
            disableClearable
            fullWidth
            loading={mdOptions.loading}
            options={mdOptions.data}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='MD' />}
            size='small'
            value={filterForm?.md_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'md_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid> */}

        <Grid md={2}>
          <Autocomplete
            id='md_id'
            multiple
            fullWidth
            filterOptions={(x) => x}
            loading={mdOptions.loading}
            options={mdOptions.data}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={Array.isArray(filterForm.md_id) ? filterForm.md_id : []}
            noOptionsText='No MD'
            onChange={(event, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [mdOptions.data[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [mdOptions.data[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter(
                  (option) => option.value !== mdOptions.data[0].value,
                );
              }

              setFilterForm({
                ...filterForm,
                md_id: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='MD' fullWidth />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>

        <Grid md={2}>
          <DesktopDatePicker
            label='month_year'
            views={['month', 'year']}
            value={filterForm?.month_year}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => (
              <TextField {...params} label='Month Year' size='small' fullWidth />
            )}
            onChange={(value) => handleChangeMonth(value)}
          />
        </Grid>

        <Grid md={4}>
          <Button variant='contained' color='success' onClick={handleGeneratelist}>
            Generate
          </Button>

          <Button
            variant='contained'
            color='primary'
            onClick={() => handleClearList()}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
